(function () {
  'use strict';

  function initSearchInput(input) {
    var sectionId = input.getAttribute('data-tgsg-section');
    var wrap      = input.parentElement;
    var clearBtn  = wrap.querySelector('[data-tgsg-clear]');
    var timer;

    function getNs() {
      return window.tgSalonGrid && window.tgSalonGrid[sectionId];
    }

    function triggerFilter() {
      var ns = getNs();
      if (!ns) return;
      ns.setSearchTerm(input.value.trim().toLowerCase());
      ns.resetOffset();
      ns.applyFilters();
    }

    input.addEventListener('input', function () {
      clearBtn.style.display = input.value.length ? '' : 'none';
      clearTimeout(timer);
      timer = setTimeout(triggerFilter, 300);
    });

    clearBtn.addEventListener('click', function () {
      input.value = '';
      clearBtn.style.display = 'none';
      clearTimeout(timer);
      var ns = getNs();
      if (!ns) return;
      ns.setSearchTerm('');
      ns.resetOffset();
      ns.applyFilters();
      input.focus();
    });
  }

  var inputs = document.querySelectorAll('[data-tgsg-search]');
  Array.prototype.forEach.call(inputs, initSearchInput);
})();
